var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"value":_vm.value && _vm.visible,"color":_vm.color,"top":"","timeout":_vm.timeout}},[_c('v-icon',{attrs:{"color":"white","left":""}},[_vm._v("mdi-information")]),_c('span',[_vm._t("default")],2),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }